var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnInit } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import { SCREEN_SIZE, ListingCategory, ListingPurchase } from '../../classes/enums';
import { HasSubscriptions } from '../has-subscriptions';
import { ListingsService } from "../../services/listings.service";
import { Pagination } from "../../classes/pagination";
import { DomManipulationService } from "../../services/dom-manipulation/dom-manipulation.service";
import { ActivatedRoute } from "@angular/router";
import { MetaTagService } from "../../services/meta-tag.service";
var ListingSitemapComponent = /** @class */ (function (_super) {
    __extends(ListingSitemapComponent, _super);
    function ListingSitemapComponent(communicationService, listingsService, domManipulationService, activatedRoute, metaTagService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.listingsService = listingsService;
        _this.domManipulationService = domManipulationService;
        _this.activatedRoute = activatedRoute;
        _this.metaTagService = metaTagService;
        _this.pagination = new Pagination(0, 75);
        _this.addSub(_this.communicationService.screenSize.subscribe(function (s) { return _this.screenSize = s; }));
        return _this;
    }
    ListingSitemapComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.listings.currentShownListingType.subscribe(function (listingType) {
            _this.currentListingType = listingType;
        }));
        this.activatedRoute.queryParams.subscribe(function (s) {
            var pageNumber = Number(s.page) || 0; // For Pagination
            // We need to remember to decrement this value as pagination arrays start from 0
            if (pageNumber > 0)
                pageNumber--;
            _this.getDirectoryLinks(pageNumber);
        });
        this.setSEOItems();
    };
    ListingSitemapComponent.prototype.getDirectoryLinks = function (newPageNumber) {
        var _this = this;
        this.pagination.pageNumber = newPageNumber;
        var listingTypes = [this.currentListingType];
        this.listingsService.searchListingsSitemap(listingTypes, ListingPurchase.SALE, this.pagination).subscribe(function (result) {
            _this.pagination.setTotalResults(result.totalHits);
            _this.links = result.results;
            _this.domManipulationService.scrollIntoView(_this.alElementRef, true);
        });
    };
    ListingSitemapComponent.prototype.setSEOItems = function () {
        var titleVariables = {};
        var descriptionVariables = {};
        var titleString = "listing-sitemap.meta-tags.title";
        var descriptionString = "listing-sitemap.meta-tags.description";
        this.metaTagService.setPageTitle(titleString, titleVariables);
        this.metaTagService.setPageDescription(descriptionString, descriptionVariables);
        var openGraphTags = [
            {
                name: 'title',
                content: titleString,
                variables: titleVariables,
                isTranslateKey: true
            },
            {
                name: 'description',
                content: descriptionString,
                variables: descriptionVariables,
                isTranslateKey: true
            }
        ];
        this.metaTagService.setOpenGraphTags(openGraphTags);
    };
    return ListingSitemapComponent;
}(HasSubscriptions));
export { ListingSitemapComponent };
